import { BuildingStorefrontIcon, FunnelIcon } from "@heroicons/react/24/solid";
import { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import * as XLSX from "xlsx";
import { getVendorList } from "../../../actions/CarrierAgreementMgmt/Vendor";
import { notificationFilterById } from "../../../actions/Utilities/NotificationFilter";
import AddButton from "../../../components/AddButton";
import ConfirmBoxDelete from "../../../components/ConfirmBoxDelete";
import DownloadButton from "../../../components/DownloadButton";
import EditButton from "../../../components/EditButton";
import MaterialVendorTable from "../../../components/tables/MaterialVendorTable";
import { toast } from "../../../components/toastNotification";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../PermissionsConstants";
import { ReportsTabs } from "../../ReportsTab/ReportsTab";
import { VendorTabs } from "../../VendorTab/VendorTab";
import { mainSelectedTab, paginationData } from "../atoms";
import { busLicensesShowState } from "../BusinessLicensesAndPermits/atoms/atoms";
import { leShowState } from "../LeasedEquipment/atom/atom";
import { officeShowState } from "../OfficeSettings/atoms/atoms";
import {
  addStateVendor,
  editStateVendor,
  onCloseFromOffice,
  rowEditIdStateVendor,
  selectedRowsStateVendor,
  vendorFromVendorHome,
  vendorSearchFilter,
  vendorShowState,
  vendorViewData,
  vendorViewId,
} from "./atoms/atoms";
import useDeleteVendor from "./hooks/useDeleteVendor";
import { useGetVendorById } from "./hooks/useGetVendorById";
import useGetVendorsForDownload from "./hooks/useGetVendorsForDownload";
import useSearchForDownload from "./hooks/useSearchForDownload";
import useVendor from "./hooks/useVendor";
import TableFilters from "./TableFilter";
import VendorForm from "./VendorForm";
import VendorView from "./views/VendorView";

const VendorTable = ({ viewFromVendorHome = false }) => {
  //Hooks Call
  const {
    data: vendorData,
    isLoading: vendorFetching,
    isSuccess: getVendorSuccess,
  } = useVendor();

  const {
    mutate: BulkDeleteVendor,
    isSuccess: editVendorInvoiceSuccess,
    data: editVendorInvoiceResult,
  } = useDeleteVendor();
  //Atoms Call

  const [filterSearchData, setFilterSearchData] =
    useRecoilState(vendorSearchFilter);
  const [actionAddState, setActionAddState] = useRecoilState(addStateVendor);
  const [actionEditState, setActionEditState] = useRecoilState(editStateVendor);
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateVendor
  );
  const [, setShowVendor] = useRecoilState(vendorShowState);
  const [, setRowToEdit] = useRecoilState(rowEditIdStateVendor);
  const [vendorTableData, setVendorTableData] = useState([]);
  const [isShow, setShowState] = useRecoilState(vendorShowState);
  const [closeFromOffice] = useRecoilState(onCloseFromOffice);
  const setRowViewData = useSetRecoilState(vendorViewData);
  const [page, setPage] = useRecoilState(paginationData);
  const [selectedData, setSelectedData] = useState([]);
  const [filter, setFilter] = useState(false);

  const [, setShowFromVendorHome] = useRecoilState(vendorFromVendorHome);

  //Local States
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [vendorFilteredData, setVendorFilteredData] = useState([]);
  const [showFromLE, setShowFromLE] = useState(false);
  const [, setShowLE] = useRecoilState(leShowState);
  const [showFromBLP, setShowFromBLP] = useState(false);
  const [, setShowBLP] = useRecoilState(busLicensesShowState);
  const [, setShowOffice] = useRecoilState(officeShowState);
  const [fromOffice, setFromOffice] = useState(false);
  const [fromOfficeVendor, setFromOfficeVendor] = useState(false);
  const [showFromSecurityAlarm, setShowFromSecurityAlarm] = useState(false);
  const [showFromSecurityCardReader, setShowFromSecurityCardReader] =
    useState(false);
  const [showFromSecurityFireAlarmSystem, setShowFromSecurityFireAlarmSystem] = useState(false);


  const [showFromSecurityOfficeKey, setShowFromSecurityOfficeKey] =
    useState(false);
  const [showFromSecurityDoorBuzzer, setShowFromSecurityDoorBuzzer] =
    useState(false);
  const [showFromOfficeSecurity, setShowFromOfficeSecurity] = useState(false);
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);

  const addPermission = PERMISSIONS.permission_vendor_add;
  const editPermission = PERMISSIONS.permission_vendor_edit;
  const deletePermission = PERMISSIONS.permission_vendor_delete;

  const userPermissions = useRecoilValue(permissionsSelector);
  const [isSuccess, setIsSuccess] = useState(false);
  const [exportVendors, setExportVendors] = useState([]);
  const [exportOfficeVendors, setExportOfficeVendors] = useState([]);
  const [vendorIdFromRedirect, setVendorIdFromRedirect] = useState("");
  const [isShowFromOfficeToVendor, setIsShowFromOfficeToVendor] = useState([]);
  const [isShowFromOfficeVendorToVendor, setIsShowFromOfficeVendorToVendor] =
    useState([]);
  const [isShowFromSecurityToVendor, setIsShowFromSecurityToVendor] = useState(
    []
  );
  const [
    isShowFromOfficeSecurityToVendor,
    setIsShowFromOfficeSecurityToVendor,
  ] = useState([]);

  const { isLoading: getVendorDetailsLoading } = useGetVendorsForDownload();
  const [isShowFromLEToVendor, setIsShowFromLEToVendor] = useState([]);
  const tableRef = useRef();

  const [filterValue, setFilterValue] = useState("");
  const [, setIsVendorData] = useState(true);
  const [focus, setFocus] = useState(false);
  const { data: searchedData } = useSearchForDownload(filterValue);
  const [vendorId, setVendorId] = useRecoilState(vendorViewId);
  const [showFromReportsLE, setShowFromReportsLE] = useState(false);
  const [, setIsLoading] = useState(false);

  const { data: vendorDataById, isSuccess: success } =
    useGetVendorById(vendorId);
  useEffect(() => {
    if (success) {
      if (vendorDataById.statusCode) {
        toast.fire("Server Error", "Cannot retrieve Vendor Data", "error");
      } else {
        setSelectedData(vendorDataById);
      }
    }
  }, [success, vendorDataById]);

  const searchClicked = () => {
    tableRef.current && tableRef.current?.retry();
    tableRef.current && tableRef.current?.onQueryChange();
  };

  const vendorSearchData = async (query) => {
    setIsLoading(true);
    const dataList = await getVendorList(query, filterValue, filterSearchData);

    setFilterValue(dataList.search);

    try {
      if (query.search?.length > 0) {
        setFocus(true);
      }
      setIsVendorData(false);
      return {
        ...dataList,
        ...filterValue,
        search: query.search,
      };
    } catch (error) {
      setIsVendorData(false);
      return { ...dataList };
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!actionEditState || vendorFilteredData?.length === 0) {
      searchClicked();
    } else if (!actionAddState || vendorFilteredData?.length === 0) {
      searchClicked();
    }
  }, [actionEditState, actionAddState]);

  useEffect(() => {
    if (getVendorSuccess && vendorData) {
      if (vendorData.statusCode) {
        toast.fire("Server Error", "Failed to retrieved Vendor data", "error");
      } else {
        setVendorTableData(vendorData?.data?.map((data) => ({ ...data })));
      }
    }
  }, [vendorData]);

  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";

  if (location.state != null) {
    recordIdFromRecent = location.state;
  }
  const [blpDataToVendor, setBlpDataToVendor] = useState([]);
  const onClickCancelShow = () => {
    if (showFromLE) {
      const url = "/vendortab/vendor";
      history.push({
        pathname: "/officesettings/leasedequipment",
        state: {
          leasedEquipmentDetails: isShowFromLEToVendor,
          action: "VendorCancel",
        },
      });
      window.location.reload();
      let userTabs = [];
      [...VendorTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowLE(true);
    }
    if (showFromBLP) {
      const url = "/vendortab/vendor";
      history.push({
        pathname: "/officesettings/buslicensesandpermits",
        state: {
          employeeId: recordIdFromRecent.employeeId,
          action: "VendorCancelToBlp",
          officeKey: "officeKey",
          blpData: blpDataToVendor,
        },
      });
      window.location.reload();
      let userTabs = [];
      [...VendorTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowBLP(true);
    }
    if (fromOfficeVendor) {
      const url = "vendortab/vendor";
      history.push({
        pathname: "/officesettings/officesetting",
        state: {
          officeVendorData: isShowFromOfficeVendorToVendor,
          action: "VendorCancelToOfficeVendor",
        },
      });
      window.location.reload();
      let userTabs = [];
      [...VendorTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setFromOfficeVendor(true);
    }
    if (fromOffice) {
      const url = "vendortab/vendor";
      history.push({
        pathname: "/officesettings/officesetting",
        state: {
          officeId: isShowFromOfficeToVendor,
          action: "VendorCancelToOffice",
        },
      });
      window.location.reload();
      let userTabs = [];
      [...VendorTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowOffice(true);
    }
    if (showFromSecurityAlarm) {
      const url = "vendortab/vendor";
      history.push({
        pathname: "/officesettings/security",
        state: {
          securityData: isShowFromSecurityToVendor,
          action: "VendorCancelToSecurityAlarm",
          officeKey: "officeKey",
        },
      });
      window.location.reload();
      let userTabs = [];
      [...VendorTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromSecurityAlarm(true);
    }
    //close from vendor to security cardreader
    if (showFromSecurityCardReader) {
      const url = "vendortab/vendor";
      history.push({
        pathname: "/officesettings/security",
        state: {
          securityData: isShowFromSecurityToVendor,
          action: "VendorCancelToSecurityCardReader",
          officeKey: "officeKey",
        },
      });
      window.location.reload();
      let userTabs = [];
      [...VendorTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromSecurityCardReader(true);
    }
    if (showFromSecurityFireAlarmSystem) {
      const url = "vendortab/vendor";
      history.push({
        pathname: "/officesettings/security",
        state: {
          securityData: isShowFromSecurityToVendor,
          action: "VendorCancelToSecurityFireAlarmSystem",
          officeKey: "officeKey",
        },
      });
      window.location.reload();
      let userTabs = [];
      [...VendorTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromSecurityFireAlarmSystem(true);
    }
    if (showFromSecurityOfficeKey) {
      const url = "vendortab/vendor";
      history.push({
        pathname: "/officesettings/security",
        state: {
          securityData: isShowFromSecurityToVendor,
          action: "VendorCancelToSecurityOK",
          officeKey: "officeKey",
        },
      });
      window.location.reload();
      let userTabs = [];
      [...VendorTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromSecurityOfficeKey(true);
    }
    if (showFromSecurityDoorBuzzer) {
      const url = "vendortab/vendor";
      history.push({
        pathname: "/officesettings/security",
        state: {
          securityData: isShowFromSecurityToVendor,
          action: "VendorCancelToSecurityDB",
          officeKey: "officeKey",
        },
      });
      window.location.reload();
      let userTabs = [];
      [...VendorTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromSecurityDoorBuzzer(true);
    }

    //Vendor to Office back button
    if (showFromOfficeSecurity) {
      const url = "vendortab/vendor";
      history.push({
        pathname: "/officesettings/officesetting",
        state: {
          officeSecurityData: isShowFromOfficeSecurityToVendor,
          action: "VendorCancelToOfficeSecurity",
          officeKey: "officeKey",
        },
      });
      window.location.reload();
      let userTabs = [];
      [...VendorTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromOfficeSecurity(true);
    }
    if (showFromReportsLE) {
      const url = "/reportstab/leased_equipment";
      history.push({
        pathname: "/reportstab/leased_equipment",
        state: {
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
    setVendorTableData(vendorTableData?.map((data) => ({ ...data })));
    setShowState(false);
    setRowViewData([]);
    setShowFromVendorHome(false);
    setIsVendorData(true);
    setVendorFilteredData([]);
    setSelectedData([]);
    localStorage.removeItem("Data");
    if (vendorFilteredData[0]?.length > 0) {
      const filteredData = vendorFilteredData[0]?.map((filtered) => ({
        ...filtered,
      }));
      setVendorFilteredData(filteredData);
    }
  };

  //here
  const onClickVendorName = (rowData) => {
    setShowState(true);
    setRowViewData({
      ...rowData,
      duedate: rowData.duedate ? rowData?.duedate.slice(0, 10) : null,
    });
    localStorage.setItem("Data", JSON.stringify(rowData));
    setVendorId(rowData.id);
  };

  useEffect(() => {
    if (viewFromVendorHome) {
      setShowState(true);
    }
    if (
      (recordIdFromRecent?.action === "SecurityAlarm") &&
      vendorData?.length > 0
    ) {
      history.replace();
      const filteredData = vendorData?.find(
        (x) => x.id === recordIdFromRecent.vendorId
      );
      setRowViewData({
        ...filteredData,
        duedate: filteredData?.duedate
          ? filteredData?.duedate.slice(0, 10)
          : null,
      });
      setShowState(true);
      setShowFromSecurityAlarm(true);
      setIsShowFromSecurityToVendor(recordIdFromRecent.securityData);
    }
    if (
      recordIdFromRecent?.action === "SecurityCardReader" &&
      vendorData?.length > 0
    ) {
      history.replace();
      const filteredData = vendorData?.find(
        (x) => x.id === recordIdFromRecent.vendorId
      );
      setRowViewData({
        ...filteredData,
        duedate: filteredData?.duedate
          ? filteredData?.duedate.slice(0, 10)
          : null,
      });
      setShowState(true);
      setShowFromSecurityCardReader(true);
      setIsShowFromSecurityToVendor(recordIdFromRecent.securityData);
    }
    if (
      (recordIdFromRecent?.action === "SecurityFireAlarmSystem") &&
      vendorData?.length > 0
    ) {
      history.replace();
      const filteredData = vendorData?.find(
        (x) => x.id === recordIdFromRecent.vendorId
      );
      setRowViewData({
        ...filteredData,
        duedate: filteredData?.duedate
          ? filteredData?.duedate.slice(0, 10)
          : null,
      });
      setShowState(true);
      setShowFromSecurityFireAlarmSystem(true);
      setIsShowFromSecurityToVendor(recordIdFromRecent.securityData);
    }
    if (
      recordIdFromRecent?.action === "SecurityOfficeKey" &&
      vendorData?.length > 0
    ) {
      history.replace();
      const filteredData = vendorData?.find(
        (x) => x.id === recordIdFromRecent.vendorId
      );
      setRowViewData({
        ...filteredData,
        duedate: filteredData?.duedate
          ? filteredData?.duedate.slice(0, 10)
          : null,
      });
      setShowState(true);
      setShowFromSecurityOfficeKey(true);
      setIsShowFromSecurityToVendor(recordIdFromRecent.securityData);
    }
    if (
      recordIdFromRecent?.action === "SecurityDoorBuzzer" &&
      vendorData?.length > 0
    ) {
      history.replace();
      const filteredData = vendorData?.find(
        (x) => x.id === recordIdFromRecent.vendorId
      );
      setRowViewData({
        ...filteredData,
        duedate: filteredData?.duedate
          ? filteredData?.duedate.slice(0, 10)
          : null,
      });
      setShowState(true);
      setShowFromSecurityDoorBuzzer(true);
      setIsShowFromSecurityToVendor(recordIdFromRecent.securityData);
    }
    if (
      recordIdFromRecent?.action === "Office Cancel" &&
      vendorData?.length > 0
    ) {
      history.replace();
      const filteredData = vendorData?.find(
        (x) => x.id === recordIdFromRecent.vendorId
      );
      setRowViewData({
        ...filteredData,
        duedate: filteredData.duedate
          ? filteredData?.duedate.slice(0, 10)
          : null,
      });
      setShowState(true);
      setShowVendor(true);
    }
    if (recordIdFromRecent?.action === "ToVendor" && vendorData?.length > 0) {
      history.replace();
      const filteredData = vendorData?.filter(
        (x) => x.id === recordIdFromRecent.vendorId
      )[0];
      setRowViewData({
        ...filteredData,
        duedate: filteredData.duedate
          ? filteredData?.duedate.slice(0, 10)
          : null,
      });
      setShowState(true);
      setShowFromLE(true);
      setIsShowFromLEToVendor(recordIdFromRecent.leasedEquipmentDetails);
    }
    if (
      recordIdFromRecent?.action === "BusinessLicensesPermits" &&
      vendorData?.length > 0
    ) {
      history.replace();
      const filteredData = vendorData.find(
        (x) => x.id === recordIdFromRecent.issuer
      );
      setBlpDataToVendor(recordIdFromRecent?.blpData);
      setRowViewData({
        ...filteredData,
        duedate: filteredData.duedate
          ? filteredData?.duedate.slice(0, 10)
          : null,
      });
      setShowState(true);
      setShowFromBLP(true);
    }
    if (
      recordIdFromRecent.action === "OfficeSettingBusLP" &&
      vendorData?.length > 0
    ) {
      history.replace();
      const filteredData = vendorData?.find(
        (x) => x.id === recordIdFromRecent.issuer
      );
      setRowViewData(filteredData);
      setShowState(true);
      setFromOffice(true);
      setIsShowFromOfficeToVendor(recordIdFromRecent.officeId);
    }
    if (
      recordIdFromRecent.action === "OfficeSettingVendor" &&
      vendorData?.length > 0
    ) {
      const filteredData = vendorData?.find(
        (x) => x.id === recordIdFromRecent.vendorId
      );
      setRowViewData({
        ...filteredData,
        duedate: filteredData.duedate
          ? filteredData?.duedate.slice(0, 10)
          : null,
      });
      setShowState(true);
      setFromOfficeVendor(true);
      setIsShowFromOfficeVendorToVendor(recordIdFromRecent.officeVendorData);
    }
    if (
      recordIdFromRecent.action === "OfficeSettingSecurity" &&
      vendorData?.length > 0
    ) {
      const filteredData = vendorData?.find(
        (x) => x.id === recordIdFromRecent.vendorId
      );
      setRowViewData({
        ...filteredData,
        duedate: filteredData.duedate
          ? filteredData?.duedate.slice(0, 10)
          : null,
      });
      setShowState(true);
      setShowFromOfficeSecurity(true);
      setIsShowFromOfficeSecurityToVendor(
        recordIdFromRecent.officeSecurityData
      );
    }
    if (recordIdFromRecent?.action === "leCancel" && vendorData?.length > 0) {
      const filteredData = vendorData?.find(
        (x) => x.id === recordIdFromRecent?.vendorId
      );
      setRowViewData(filteredData);
      setShowState(true);
    }
    if (
      recordIdFromRecent?.action === "LeasedEquipmentReports" &&
      vendorData?.length > 0
    ) {
      history.replace();
      const filteredData = vendorData?.filter(
        (x) => x.id === recordIdFromRecent?.vendorId
      )[0];
      setRowViewData({
        ...filteredData,
        duedate: filteredData.duedate
          ? filteredData?.duedate.slice(0, 10)
          : null,
      });
      setShowState(true);
      setShowFromReportsLE(true);
    }
    if (recordIdFromRecent?.action === "leCancel" && vendorData?.length > 0) {
      const filteredData = vendorData?.find(
        (x) => x.id === recordIdFromRecent?.vendorId
      );
      setRowViewData(filteredData);
      setShowState(true);
    }
    if (recordIdFromRecent && recordIdFromRecent.moduleName === "Vendor") {
      const fetchData = async () => {
        try {
          const result = await notificationFilterById(
            recordIdFromRecent.recordId,
            recordIdFromRecent.moduleName,
            recordIdFromRecent.subModuleName
          );
          const transformedResult = [
            result.vendorList ?? [],
            result.officeVendorList ?? [],
          ];

          setVendorFilteredData(transformedResult);
        } catch (error) { }
      };
      const recordIds =
        recordIdFromRecent &&
        recordIdFromRecent.recordId?.split(".").map((id) => Number(id.trim()));
      const filterValue = vendorData?.filter((x) => recordIds?.includes(x.id));

      setFilterSearchData({
        vendorId: recordIdFromRecent?.recordId?.split(".")?.join(",") || "",
        vendorName: filterValue?.[0]?.name || "",
      });
      fetchData();
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, [history, recordIdFromRecent, vendorData]);

  useEffect(() => {
    // Clear state when the user refreshes the page
    const handleRefresh = () => {
      sessionStorage.clear();
    };

    window.addEventListener("beforeunload", handleRefresh);
    return () => window.removeEventListener("beforeunload", handleRefresh);
  }, []);

  useEffect(() => {
    return () => {
      setFilterSearchData({
        vendorId: "",
        vendorName: "",
      });
    };
  }, [location.pathname]);

  useEffect(() => {
    const idFromRedirect = localStorage.getItem("vendorIdRedirect");
    setVendorIdFromRedirect(idFromRedirect);
  }, []);

  useEffect(() => {
    const data = vendorData?.filter((x) => x.id === +vendorIdFromRedirect)[0];
    if (
      data &&
      location.state &&
      location.state.action === "RedirectToVendor"
    ) {
      setShowState(true);
      setRowViewData(data);
      setSelectedData(data);
      localStorage.setItem("Data", JSON.stringify(data));
    }
  }, [vendorData]);

  useEffect(() => {
    setActionAddState(false);
    setActionEditState(false);
    setSelectedRows([]);
    setVendorFilteredData([]);
  }, []);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows
      .filter((x) => x.isInActive === false || x.isInActive === "False")
      .map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      });
    setSelectedRows(forDelete);
  };

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.id);
    BulkDeleteVendor(ids);
    setOpenModalDelete(false);
    setDisabledButton(false);
    setSelectedRows([]);
  };

  //edit form
  const handleEdit = (rowData) => {
    setActionEditState(!actionEditState);
    setActionAddState(false);
    setRowToEdit({
      ...rowData,
      physicalLocation:
        (rowData.street !== "" && rowData.street !== " "
          ? rowData.street + ", "
          : "") +
        (rowData.city !== "" ? rowData.city + ", " : "") +
        (rowData.state !== "" ? rowData.state + " " : "") +
        (rowData.zipCode !== "" ? rowData.zipCode + ", " : "") +
        (rowData.street || rowData.city || rowData.state || rowData.zipCode
          ? rowData.country
            ? rowData.country + "A"
            : ""
          : ""),
      modifiedDate: rowData.modifiedDate
        ? new Date(rowData.modifiedDate).toLocaleDateString()
        : "",
      duedate: rowData.duedate ? rowData.duedate.slice(0, 10) : null,
    });
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${selectedRows?.length
      } ${selectedRows?.length > 1 ? "Vendors" : "Vendor"} ?`}</div>
  );
  useEffect(() => {
    if (closeFromOffice) {
      setShowState(true);
      const item = JSON.parse(localStorage.getItem("Data") || "");
      setRowViewData(item);
      setSelectedData(item);
    }
  }, [closeFromOffice]);

  const matColumns = [
    {
      title: "Vendor Name",
      field: "name",
      render: (rowData) => {
        return (
          <span
            className="blueAndBold underline cursor-pointer truncate"
            onClick={() => onClickVendorName(rowData)}
          >
            {rowData.name}
          </span>
        );
      },
    },
    {
      title: "Vendor Code",
      field: "vendorCode",
      sorting: false,
    },
    {
      title: "Type",
      field: "vendorTypeName",
      sorting: false,
    },
    {
      title: "Phone",
      field: "phone",
      sorting: false,
    },
    {
      title: "Physical Street",
      field: "street",
      sorting: false,
    },
    {
      title: "Physical State",
      field: "state",
      sorting: false,
    },
    {
      title: "Inactive Account",
      field: "status",
      render: (rowData) => {
        return (
          <div className="font-sans uppercase mr-4 text-xs">
            {rowData.status}
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center",
      render: (rowData) => {
        return (
          userPermissions.includes(editPermission) && (
            <div className="grid grid-col-1 justify-items-center mr-6">
              <EditButton
                disabled={disabledButton || selectedRows.length > 0}
                onClick={() => {
                  handleEdit(rowData);
                  setIsVendorData(true);
                }}
              />
            </div>
          )
        );
      },
    },
  ];

  let prevPage = new URLSearchParams(window.location.search).get("prevPage");
  useEffect(() => {
    if (prevPage !== null && actionAddState) {
      setPage(page);
    } else if (prevPage !== null && actionEditState) {
      setPage(page);
    } else if (prevPage !== null && isShow) {
      setPage(page);
    } else if (prevPage !== null && tableRef.current !== Number(prevPage)) {
      tableRef.current = page;
    }
  });
  // Download For Vendor
  const exportVendorData = (allVendorData) => {
    // For Vendor Details
    setExportVendors(
      allVendorData[0]?.map((x) => {
        return {
          "Vendor Name": x.name,
          "Vendor Code": x.vendorCode,
          Street: x.street,
          City: x.city,
          State: x.state,
          "Zip Code": x.zipCode,
          Email: x.email,
          Website: x.website,
          "Account Number": x.accountNumber,
          Contact: x.contact,
          "Vendor Type Name": x.vendorTypeName,
          "Recurrency of Service": x.vendorRecurrencyName,
          "Toner Request Email": x.tonerRequestEmail,
          "Toner Request Phone": x.tonerRequestPhone,
          "Location Longitude": x.locationLongitude,
          "Location Latitude": x.locationLatitude,
          Phone: x.phone,
          Country: x.country,
          "Vendor Password": x.vendorPassword,
          "Vendor User": x.vendorUser,
          "Payment Terms": x.duedate === null ? "" : "Net " + x.paymentTerms,
          "Created By": x.createdBy,
          "Created Date": x.createdDate,
          "Modified By": x.modifiedBy,
          "Modified Date": x.modifiedDate,
        };
      })
    );
    // For Vendor Office Service
    setExportOfficeVendors(
      allVendorData[1]?.map((x) => {
        return {
          "Record Number": x.recordNumber,
          "Vendor Name": x.name,
          "Vendor ID": x.vendorCode,
          "Office Name": x.officeName,
          "Office Vendor Account Number": x.ovsAccountNumber,
          "Bank Account": x.bankAccount,
          Contact: x.contact,
          Phone: x.phone,
          "Service Provided": x.servicesProvided,
          "Meter Number": x.meterNumber,
          W9: x.w9,
          "Invoice Availability Day": x.invoiceAvailabilityDay,
          "GL Sub Accounts": x.glSubAccounts,
          Street: x.street,
          City: x.city,
          State: x.state,
          "Zip Code": x.zipCode,
          Country: x.country,
          Email: x.email,
          Website: x.website,
          "Vendor Type": x.vendorTypeName,
          "Vendor Account Number": x.accountNumber,
          "Toner Request Email": x.tonerRequestEmail,
          "Toner Request Phone": x.tonerRequestPhone,
          "Location Longitude": x.locationLongitude,
          "Location Latitude": x.locationLatitude,
          "Vendor Password": x.vendorPassword,
          "Vendor User": x.vendorUser,
          "Created By": x.createdBy,
          "Created Date": x.createdDate,
          "Modified By": x.modifiedBy,
          "Modified Date": x.modifiedDate,
        };
      })
    );
    // Toaster on Success
    toast.fire(
      "Download Vendor ",
      "Successfully downloaded vendor.",
      "success"
    );
    setIsSuccess(true);
  };

  useEffect(() => {
    if (isSuccess) {
      // For getting vendor details
      const vendors = XLSX.utils.json_to_sheet(exportVendors);
      const vendorOffice = XLSX.utils.json_to_sheet(exportOfficeVendors);

      const wb = XLSX.utils.book_new();

      // For additional sheet in excel
      XLSX.utils.book_append_sheet(wb, vendors, "Vendor Details");
      XLSX.utils.book_append_sheet(wb, vendorOffice, "Office Vendor Service");
      XLSX.writeFile(
        wb,
        "VendorDownloadedFile_" + new Date()?.toLocaleDateString() + ".xlsx"
      );
      setIsSuccess(false);
    }
  }, [isSuccess]);

  useEffect(() => {
    if (
      editVendorInvoiceSuccess &&
      editVendorInvoiceResult?.status === 204 &&
      recordIdFromRecent === ""
    ) {
      searchClicked();
    }
  }, [editVendorInvoiceSuccess, editVendorInvoiceResult]);

  return (
    <>
      <div className="px-8 py-4 min-h-fit">
        {actionAddState ? (
          ""
        ) : (
          <div className="font-bold text-primary text-xl uppercase "> </div>
        )}
        {!actionAddState && !actionEditState && (
          <div className="space-y-2">
            {/* here */}
            {!isShow && (
              <div className="w-full space-y-2">
                <div className="flex flex-row justify-between  ">
                  <div>
                    <div className="flex gap-2 items-center">
                      <div>
                        <BuildingStorefrontIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                      </div>
                      <div className="flex flex-col leading tight">
                        <h3 className="text-xs font-medium text-gray-500">
                          Vendor Module
                        </h3>
                        <h1 className="mr-auto font-bold text-primary text-md uppercase">
                          All Vendors
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-row justify-between">
                  <div className="flex items-center w-full justify-between">
                    <div className="space-x-4">
                      <button
                        className="hover:scale-90 transition duration-500 flex justify-center items-center shadow-md px-3 py-1 h-7 text-xs 
                        gap-x-2 font-semibold text-primary border hover:bg-primary selected hover:text-white border-primary rounded-md"
                        onClick={() => {
                          setFilter(!filter);
                        }}
                      >
                        <div>Filter By</div>
                        <FunnelIcon className="h-3 w-3 focus:bg-primary" />
                      </button>
                    </div>
                    <div className="flex items-center gap-2 flex-row">
                      {userPermissions.includes(addPermission) ? (
                        <AddButton
                          buttonText="Add"
                          className={
                            selectedRows.length > 0 || actionEditState
                              ? "opacity-50"
                              : "opacity-100"
                          }
                          onClick={() => {
                            setActionAddState(!actionAddState);
                            setIsVendorData(true);
                          }}
                          disabled={disabledButton || selectedRows.length > 0}
                        />
                      ) : (
                        ""
                      )}
                      <DownloadButton
                        disabled={getVendorDetailsLoading}
                        buttonValue={"Download File"}
                        onClick={() => {
                          exportVendorData(
                            vendorFilteredData?.length > 0
                              ? vendorFilteredData
                              : searchedData?.length > 0
                                ? searchedData
                                : vendorTableData
                          );
                        }}
                        className={undefined}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="flex">
              {filter && (
                <div className="overflow-y-auto flex-col flex-grow bg-white w-1/4">
                  <div className="mb-4">
                    <TableFilters
                      filter={filter}
                      vendorSearchData={vendorSearchData}
                      searchClicked={searchClicked}
                    />
                  </div>
                </div>
              )}
              <div className={`flex flex-col ${filter ? "w-3/4" : "w-full"}`}>
                {/* {userPermissions.includes(deletePermission) && (
                  <div className="text-secondary pb-2 italic text-xs3">
                    <div>
                      <p className="self-center font-bold italic inline-block mr-1">
                        Note:{" "}
                      </p>
                      Tick the box to deactivate some data.
                    </div>
                  </div>
                )} */}
                <div className="w-full">
                  {!isShow && (
                    <MaterialVendorTable
                      search={true}
                      toolbar={true}
                      tableRef={tableRef}
                      columns={matColumns}
                      data={vendorSearchData}
                      selection={userPermissions.includes(deletePermission)}
                      setOpenModal={setOpenModalDelete}
                      onSelectionChange={handleSelectedRowsChange}
                      selectedRows={selectedRows}
                      isLoading={vendorFetching}
                      searchAutoFocus={focus}
                    />
                  )}
                  {isShow && (
                    <VendorView
                      data={selectedData}
                      onClickCancelShow={onClickCancelShow}
                      handleEdit={handleEdit}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        {actionAddState && (
          <div className="">
            <VendorForm />
          </div>
        )}
        {actionEditState && (
          <div className="">
            <VendorForm />
          </div>
        )}
        <ConfirmBoxDelete
          ModalTitle="Deactivate Vendor"
          qConfirmation={deleteMessage}
          isOpen={openModalDelete}
          onClose={() => setOpenModalDelete(false)}
          onClickFunction={handleBulkDelete}
        />
      </div>
    </>
  );
};

export default VendorTable;
